import { render, staticRenderFns } from "./IndexAsideStatic.vue?vue&type=template&id=9f3040c6&scoped=true&"
import script from "./IndexAsideStatic.vue?vue&type=script&lang=js&"
export * from "./IndexAsideStatic.vue?vue&type=script&lang=js&"
import style0 from "./IndexAsideStatic.vue?vue&type=style&index=0&id=9f3040c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3040c6",
  null
  
)

export default component.exports